module.exports = __webpack_public_path__ + "img/gameOverview-active.8dec16f2.svg";